import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Fragment, useMemo } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/react';
import { ArrowIconWrapper, StyledSelectHelperText, ListboxButtonContent, ListboxContentWrapper, SelectMainWrapper, StyledPlaceholder, SecondaryLabel, selectLabelStyle, selectInteractiveAreaStyle, selectOptionsStyle, selectOptionStyle } from './select.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function Select(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      secondaryLabel = _ref.secondaryLabel,
      value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      fullwidth = _ref.fullwidth,
      wrapperStyle = _ref.wrapperStyle,
      isContentCentered = _ref.isContentCentered,
      _ref$helperText = _ref.helperText;
  _ref$helperText = _ref$helperText === void 0 ? {
    variant: 'error',
    message: ''
  } : _ref$helperText;
  var helperTextVariant = _ref$helperText.variant,
      helperTextMessage = _ref$helperText.message,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$tertiaryLabel = _ref.tertiaryLabel,
      tertiaryLabel = _ref$tertiaryLabel === void 0 ? '' : _ref$tertiaryLabel,
      _ref$optionListPlacem = _ref.optionListPlacement,
      optionListPlacement = _ref$optionListPlacem === void 0 ? 'bottom' : _ref$optionListPlacem;
  var placeholderEl = useMemo(function () {
    return /*#__PURE__*/_jsx(StyledPlaceholder, {
      children: placeholder
    });
  }, [placeholder]);

  var _useFloating = useFloating({
    placement: optionListPlacement,
    middleware: [offset(8), flip(), shift()],
    whileElementsMounted: autoUpdate
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles;

  return /*#__PURE__*/_jsx(SelectMainWrapper, {
    fullwidth: fullwidth,
    twStyle: wrapperStyle,
    children: /*#__PURE__*/_jsx(Listbox, {
      value: value,
      onChange: onChange,
      children: function children(_ref2) {
        var open = _ref2.open;
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(ListboxContentWrapper, {
            children: [label && /*#__PURE__*/_jsxs(StyledListboxLabel, {
              disabled: disabled,
              children: [/*#__PURE__*/_jsx("span", {
                children: label
              }), " ", /*#__PURE__*/_jsx(SecondaryLabel, {
                children: secondaryLabel
              })]
            }), /*#__PURE__*/_jsxs(StyledListboxButton, {
              "aria-disabled": disabled,
              disabled: disabled,
              ref: refs.setReference,
              children: [/*#__PURE__*/_jsxs(_StyledListboxButtonContent, {
                twStyle: isContentCentered ? {
                  "marginLeft": "auto",
                  "marginRight": "auto"
                } : {},
                children: [tertiaryLabel ? /*#__PURE__*/_jsx("span", {
                  children: tertiaryLabel
                }) : null, value !== null && value !== void 0 && value.Icon ? /*#__PURE__*/_jsx(value.Icon, {
                  className: "text-neutral-700 h-4 w-4 min-w-4 min-h-4"
                }) : null, value !== null && value !== void 0 && value.icon ? value.icon : null, value ? value.label : placeholderEl]
              }), /*#__PURE__*/_jsx(ArrowIconWrapper, {
                isOpen: open,
                children: /*#__PURE__*/_jsx(ChevronDownIcon, {
                  className: "h-6 w-6 text-neutral-700",
                  "aria-hidden": "true"
                })
              })]
            }), /*#__PURE__*/_jsx(Transition, {
              as: Fragment,
              leave: "transition ease-in duration-100",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /*#__PURE__*/_jsx(StyledListboxOptions, {
                style: _objectSpread({}, floatingStyles),
                ref: refs.setFloating,
                children: options === null || options === void 0 ? void 0 : options.map(function (option, index) {
                  var Icon = option.Icon,
                      label = option.label,
                      icon = option.icon;
                  return /*#__PURE__*/_jsx(Listbox.Option, {
                    value: option,
                    children: function children(_ref3) {
                      var active = _ref3.active;
                      return /*#__PURE__*/_jsxs(StyledListboxOption, {
                        active: active,
                        twStyle: isContentCentered ? {
                          "justifyContent": "center"
                        } : {},
                        children: [Icon ? /*#__PURE__*/_jsx(Icon, {
                          className: "text-neutral-700 h-6 w-6"
                        }) : null, icon ? icon : null, /*#__PURE__*/_jsx("span", {
                          children: label
                        })]
                      });
                    }
                  }, index);
                })
              })
            })]
          }), helperTextMessage && /*#__PURE__*/_jsx(StyledSelectHelperText, {
            variant: helperTextVariant,
            children: helperTextMessage
          })]
        });
      }
    })
  });
}
export default Select;

var StyledListboxLabel = /*#__PURE__*/_styled(Listbox.Label).withConfig({
  displayName: "select__StyledListboxLabel",
  componentId: "sc-101o3sr-0"
})(["", " ", ""], selectLabelStyle, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? {
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))"
  } : {};
});

var StyledListboxButton = /*#__PURE__*/_styled(Listbox.Button).withConfig({
  displayName: "select__StyledListboxButton",
  componentId: "sc-101o3sr-1"
})(["", " ", ""], selectInteractiveAreaStyle, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? {
    "cursor": "not-allowed",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
    }
  } : {};
});

var StyledListboxOptions = /*#__PURE__*/_styled(Listbox.Options).withConfig({
  displayName: "select__StyledListboxOptions",
  componentId: "sc-101o3sr-2"
})(["", ""], selectOptionsStyle);

var StyledListboxOption = /*#__PURE__*/_styled.span.withConfig({
  displayName: "select__StyledListboxOption",
  componentId: "sc-101o3sr-3"
})(["", " ", " ", " ", ""], selectOptionStyle, {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
}, function (_ref6) {
  var active = _ref6.active;
  return active ? {
    "display": "flex",
    "height": "3rem",
    "width": "100%",
    "alignItems": "center",
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
  } : {};
}, function (_ref7) {
  var twStyle = _ref7.twStyle;
  return twStyle || {};
});

var _StyledListboxButtonContent = /*#__PURE__*/_styled(ListboxButtonContent).withConfig({
  displayName: "select___StyledListboxButtonContent",
  componentId: "sc-101o3sr-4"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.25rem"
});